import mirageGraphQLFieldResolver from "./mirage-mjs";

function getOptionalResolver(info, optionalResolvers) {
  var fieldName = info.fieldName,
      parentType = info.parentType;
  return optionalResolvers && optionalResolvers[parentType.name] && optionalResolvers[parentType.name][fieldName];
}

export default function createFieldResolver(optionalResolvers) {
  return function fieldResolver(_obj, _args, _context, info) {
    var optionalResolver = getOptionalResolver(info, optionalResolvers);

    if (optionalResolver) {
      return optionalResolver.apply(void 0, arguments);
    }

    return mirageGraphQLFieldResolver.apply(void 0, arguments);
  };
}
